// FassalkartAI - Farmer Protected Route

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../ui/LoadingScreen';

/**
 * Allows access only to authenticated farmers (role: farmer | officer).
 * Redirects to /login if not authenticated.
 * Redirects to /onboarding if farmer profile is incomplete.
 */
const ProtectedRoute = ({ children }) => {
  const { currentUser, userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen message="Checking authentication..." />;

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect companies to B2B portal
  if (userProfile?.role === 'company') {
    return <Navigate to="/b2b/dashboard" replace />;
  }

  // Redirect admins to admin panel
  if (userProfile?.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  // Redirect farmers who haven't completed onboarding
  // Loop-guard: skip if already on /onboarding
  if (
    userProfile &&
    userProfile.role === 'farmer' &&
    !userProfile.onboardingComplete &&
    location.pathname !== '/onboarding'
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default ProtectedRoute;
